<template>
  <div
    class="d-flex align-items-center"
    :class="{
      'w-100': label == 'nolabel',
    }"
    ref="dropdownWrapper"
  >
    <div class="w-40" v-if="label != 'nolabel'">
      <label class="mb-0 fs-14 fw-500 font-mont color-344054">
        {{ label }}<span v-if="mandatory" class="color-red">*</span>
      </label>
    </div>
    <section
      class="w-60"
      :class="{
        'w-100': label == 'nolabel',
      }"
    >
      <div
        :class="[
          {
            pointer: !disabled,
            'disabled-dropdown': disabled,
            'border-error': error,
          },
          'filter-inner-dropdown',
          'position-relative',
        ]"
        @click="toggleDropdown"
      >
        <span
          :class="
            selected
              ? 'font-mont fs-14 fw-500 color-black'
              : 'fw-400 fs-12 font-mont color-adaaaa'
          "
          class="text-capitalize"
        >
          {{ getSelectedLabel || "Select" }}
        </span>
        <img
          :class="{
            rotate180deg: opendropdown,
          }"
          src="../../assets/dashboard/small-down-arrow.svg"
          alt=""
        />
      </div>

      <div v-if="opendropdown" class="position-relative">
        <div
          class="singleselect filter-radio-dropdown filter-cand overflow-hidden p-0"
        >
          <b-form-group class="w-100">
            <div class="overflow">
              <b-form-radio-group
                class="filter-radio-dropdown-inner-content w-100 position-relative text-capitalize"
                size="sm"
                v-model="selected"
                :options="options"
                buttons
                stacked
                text-field="name"
                value-field="item"
                :disabled="disabled"
                @change="opendropdown = false"
              />
            </div>
          </b-form-group>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    mandatory: Boolean,
    label: String,
    value: [String, Number],
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opendropdown: false,
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    getSelectedLabel() {
      const match = this.options.find((o) => o.item === this.selected);
      return match ? match.name : "";
    },
  },
  methods: {
    toggleDropdown() {
      if (!this.disabled) {
        this.opendropdown = !this.opendropdown;
        if (this.opendropdown) {
          this.$emit("dropdown-opened");
        }
      }
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdownWrapper;
      if (dropdown && !dropdown.contains(event.target)) {
        this.opendropdown = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.opacity-50 {
  opacity: 0.5;
}
.border-error {
  border: 1px solid red !important;
  border-radius: 8px;
}
.disabled-dropdown {
  background: #f7f7f7;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border: unset;
}
</style>
